export default __webpack_public_path__ + "static/media/Token Distribution.9a30b72f.png";